import { useQuery } from '@tanstack/react-query';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { fetchPrimaryLinkedMember, fetchSecondaryLinkedMembers } from './infiniteLinkedMembers';

export function useInfiniteLinkedMembers(profile: App.LuxLoyaltyInfiniteProfile | null | undefined) {
  const brand = useCurrentBrand();
  const isPrimaryProfile = profile?.role === 'PRIMARY';
  const primaryAccountNumber = profile?.primaryAccountNumber ?? null;
  const applicationId = profile?.applicationId ?? null;

  const primaryQuery = useQuery({
    queryKey: ['lux-loyalty', 'infinite-linked-members', 'primary', primaryAccountNumber],
    queryFn: () => fetchPrimaryLinkedMember(primaryAccountNumber as number),
    enabled: Boolean(profile && !isPrimaryProfile && primaryAccountNumber),
    retry: false,
  });

  const secondariesQuery = useQuery({
    queryKey: ['lux-loyalty', 'infinite-linked-members', 'secondaries', applicationId, brand],
    queryFn: ({ signal }) => fetchSecondaryLinkedMembers(applicationId as string, brand, signal),
    enabled: Boolean(profile && isPrimaryProfile && applicationId),
    retry: false,
  });

  if (!profile) {
    return {
      isPrimaryProfile: false,
      members: [],
      isLoading: false,
      isError: false,
    };
  }

  if (isPrimaryProfile) {
    return {
      isPrimaryProfile: true,
      members: secondariesQuery.data ?? [],
      isLoading: secondariesQuery.isLoading,
      isError: secondariesQuery.isError,
    };
  }

  return {
    isPrimaryProfile: false,
    members: primaryQuery.data ? [primaryQuery.data] : [],
    isLoading: primaryQuery.isLoading,
    isError: primaryQuery.isError,
  };
}
